<script>
export default {
  props: {
    value: {
      type: Array
    },
    longTooltip: {
      type: Boolean
    }
  },
  data: vm => ({
    actions: {
      [vm.$enums.UserActionRequired.postage]: {
        content: 'component.documentValidation.userActionRequiredList.need.franking.on.envelope.confirmation',
        tooltip: 'component.documentValidation.userActionRequiredList.tooltip.need.franking.on.envelope.confirmation'
      },
      [vm.$enums.UserActionRequired.productionNote]: {
        content: 'component.documentValidation.userActionRequiredList.need.production.area.confirmation',
        tooltip: 'component.documentValidation.userActionRequiredList.tooltip.need.production.area.confirmation'
      },
      [vm.$enums.UserActionRequired.font]: {
        content: 'component.documentValidation.userActionRequiredList.need.font.confirmation',
        tooltip: 'component.documentValidation.userActionRequiredList.tooltip.need.font.confirmation'
      },
      [vm.$enums.UserActionRequired.duplicates]: {
        content: 'component.documentValidation.userActionRequiredList.need.duplicates.delete.confirmation',
        tooltip: 'component.documentValidation.userActionRequiredList.tooltip.duplicates.delete.confirmation'
      },
      [vm.$enums.UserActionRequired.unapproved]: {
        content: 'component.documentValidation.userActionRequiredList.need.unapproved.files.delete.confirmation',
        tooltip: 'component.documentValidation.userActionRequiredList.tooltip.unapproved.files.delete.confirmation'
      }
    }
  })
}
</script>
<template>
  <v-card-text>
    <div v-for="(warning, index) in value" :key="index">
      {{ $t(actions[warning].content) }}
      <v-tooltip top max-width="550" content-class="dark_tip">
        <template #activator="{ on, attrs }">
          <a v-bind="attrs" color="red" v-on="on">
            <v-icon color="primary">mdi-information-outline</v-icon
            >{{ $t('component.documentValidation.userActionRequiredList.more.infos') }}</a>
        </template>
        <span
          v-html="$t(longTooltip
                ? actions[warning].tooltip + '.long'
                : actions[warning].tooltip)"
        ></span>
      </v-tooltip>
    </div>
  </v-card-text>
</template>
